export default {
	categories: {
		report: {
			'antibody_barcoding': "Código de barras de anticorpo",
			'antisaccade_task': "Tarefa anti-sacádico",
			'body_fluid': "Fluido corporal",
			'canards_sign': "Sinal de Canards",
			'cit_program_tumor_identity_cards': "CTI Cartões de identidade de tumor",
			'companion_diagnostic': "Diagnóstico complementar",
			'coordinated_diagnostics': "Diagnóstico coordenado",
			'cosmed': "COSMED",
			'cryoglobulinemia': "Crioglobulinemia",
			'diagnostic_overshadowing': "Diagnóstico sombra",
			'differential_diagnosis': "Diagnóstico diferencial",
			'directhit': "Ataque directo",
			'dot_cancellation_test': "Teste de cancelamento de pontos",
			'drehmann_sign': "Sinal de Drehmann",
			'elbow_extension_test': "Teste de extensão do cotovelo",
			'electrophysiological_techniques_for_clinical_diagnosis': "Técnicas eletrofisiológicas para diagnóstico clínico",
			'external_cause': "Causa externa",
			'fast_(stroke)': "AVC",
			'fine-needle_aspiration': "Aspiração por agulha fina",
			'flow-mediated_dilation': "Dilatação mediada por fluxo",
			'frax': "FRAX",
			'gender-bias_in_medical_diagnosis': "Viés de gênero no diagnóstico médico",
			'immunolabeling': "Identificação imunológica",
			'instantaneous_wave-free_ratio': "Proporção instantânea de ondas livres",
			'laboratory_diagnosis_of_viral_infections': "Diagnóstico laboratorial de infecções virais",
			'martha_mitchell_effect': "Efeito Martha Mitchell",
			'medical_findings': "Descobertas médicas",
			'medical_laboratory': "Laboratório médico",
			'mental_status_examination': "Exame do estado mental",
			'microvesicles': "Microvesículas",
			'nasoendoscopy': "Nasoendoscopia",
			'nekrep_case': "Caso Nekrep",
			'nucleic_acid_test': "Teste de ácido nucleico",
			'oswestry_disability_index': "Índice de Incapacidade Oswestry",
			'overdiagnosis': "Sobrediagnóstico",
			'paternity': "Paternidade",
			'pericardiocentesis': "Pericardiocentese",
			'photoacoustic_effect': "Efeito fotoacústico",
			'prati_criteria': "Critérios Prati",
			'pseudothrombocytopenia': "Pseudotrombocitopenia",
			'psychiatric_assessment': "Avaliação psiquiátrica",
			'psychiatric_interview': "Entrevista psiquiátrica",
			'qns': "QNS",
			'radiopharmaceutical': "Radiofarmacêutico",
			'rectal_discharge': "Descarga rectal",
			'schooliosis': "Escoliose",
			'surgical_sieve': "Crivo cirúrgico",
			'sutton´s_law': "Lei de Sutton",
		},
		relations: {
			'other': "Outro",
			'doctor': "Doutor",
			'father': "Pai",
			'mother': "Mãe",
			'son': "Filho",
			'daughter': "Filha",
		},
		diseases: {
			'alergias': "Alergias",
			'alzheimer´s_disease': "Doença de Alzheimer",
			'amyotrophic_lateral_sclerosis_(als)': "Esclerose Lateral Amiotrófica (ELA)",
			'aneurisma': "Aneurisma",
			'ansiedade': "Ansiedade",
			'arrhythmia_of_the_heart': "Arritmia do Coração",
			'arthritis': "Artrite",
			'asma': "Asma",
			'atrial_fibrillation': "Fibrilação atrial",
			'autism': "Autismo",
			'avc': "AVC",
			'bedsores_(pressure_ulcers)': "Escaras (úlceras de pressão)",
			'bipolar_disorder_(manic-depressive_illness)': "Transtorno bipolar (doença maníaco-depressiva)",
			'bócio': "Bócio",
			'cancer': "Cancro",
			'cataracts': "Cataratas",
			'cholesterol': "Colesterol",
			'chronic_kidney_failure': "Insuficiência Renal Crônica",
			'coagulação_na_sangue': "Coagulação no sangue",
			'copd,_or_chronic_obstructive_pulmonary_disease': "DPOC ou doença pulmonar obstrutiva crônica",
			'depressão': "Depressão",
			'diabetes': "Diabetes",
			'diminuição_auditiva': "Diminuição auditiva",
			'esquizofrenia': "Esquizofrenia",
			'fibrilhação_auricular': "Fibrilhação auricular",
			'fibromyalgia': "Fibromialgia",
			'glaucoma': "Glaucoma",
			'heart_disease': "Doença cardíaca",
			'hepatitis': "Hepatite",
			'hiv/aids': "VIH / SIDA",
			'hypertension_(high_blood_pressure)': "Hipertensão (pressão alta)",
			'hyperthyroidism_(overactive_thyroid)': "Hipertireoidismo (tireóide hiperativa)",
			'hypothyroidism_(underactive_thyroid)': "Hipertireoidismo (tireóide hipoativa)",
			'incontinence,_urinary': "Incontinência Urinária",
			'inflammatory_bowel_disease_(ibd)': "Doença inflamatória intestinal (DII)",
			'irritable_bowel_syndrome_(ibs)': "Síndrome do Intestino Irritável (SII)",
			'kidney_failure,_chronic': "Insuficiência Renal Crônica",
			'leukemia': "Leucemia",
			'liver_failure,_acute': "Insuficiência hepática aguda",
			'liver_spots_(age_spots)': "Manchas no fígado (manchas de idade)",
			'lupus': "Lúpus",
			'lymphoma,_hodgkin´s_(hodgkin´s_disease)': "Linfoma de Hodgkin (doença de Hodgkin)",
			'lymphoma,_non-hodgkin´s': "Linfoma não-Hodgkin",
			'macular_degeneration,_dry': "Degeneração macular seca",
			'mastectomia': "Mastectomia",
			'melanoma,_skin_cancer': "Melanoma, Cancro da pele",
			'multiple_sclerosis_(ms)': "Esclerose Múltipla (EM)",
			'obstructive_sleep_apnea': "Apneia obstrutiva do sono",
			'osteoarthritis': "Osteoartrite",
			'osteoporosis': "Osteoporose",
			'pancreatic_cancer': "Cancro do pâncreas",
			'parkinson´s_disease': "Doença de Parkinson",
			'periodontitis': "Periodontite",
			'pneumonia': "Pneumonia",
			'post-traumatic_stress_disorder_(ptsd)': "Transtorno de stress pós-traumático (TSPT)",
			'psoriasis': "Psoríase",
			'rheumatoid_arthritis': "Artrite reumatóidev",
			'rinite': "Rinite",
			'staph_infections': "Infecções por estafilococos",
			'stroke': "AVC",
			'thrush,_oral': "Tordo oral",
			'transient_ischemic_attack_(tia)': "Ataque Isquêmico Transitório (AIT)",
			'tuberculosis_(tb)': "Tuberculose (TB)",
			'ulcerative_colitis': "Colite Ulcerativa",
			'vascular_dementia': "Demencia vascular",
			'vertigo': "Vertigens",
			'wrinkles': "Rugas",
		}
	}
}



// WEBPACK FOOTER //
// ./src/i18n/categories/categories_pt.js